var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full overflow-x-auto overflow-y-hidden"},[_c('div',{staticClass:"flex flex-wrap tabs-inner-wrapper mt-1"},_vm._l((_vm.items),function(item,index){return _c('div',{key:("tab-" + index),class:{
        'tab-item px-4 py-4 cursor-pointer font-bold uppercase': true,
        'text-gray-500': !item.isActive,
        'text-oDark tab-item-active': item.isActive,
      },on:{"click":function($event){return _vm.onTabClick(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }